import { call, put, takeLatest } from "redux-saga/effects";
import {
  getClassSectionRequest,
  getClassSectionSuccess,
  getClassSectionFailure,
} from "./classSectionSlice"; 
import classSection from "../../data/classSection.json";
import { GetAllClassWithDetailsMapping } from "../../api/ClassPeriods/ClassWithStrSubsSecService";

function* fetchClassSectionSaga(action) {
  try {
    const {schoolID, academicYearID} =action.payload;
    const response = yield call(GetAllClassWithDetailsMapping, schoolID, academicYearID);
    yield put(getClassSectionSuccess(response?.data)); 
  } catch (error) {
    yield put(getClassSectionSuccess([])); 
    // yield put(getClassSectionFailure(error.message || "Something went wrong"));
  }
}

export default function* watchClassSection() {
  yield takeLatest(getClassSectionRequest.type, fetchClassSectionSaga);
}

